import styled from "styled-components";
import { Button } from "@aidron/aidron-ds";

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTextField = styled.div`
  div.textfield-outer div.ragnarok.textfield-wrapper {
    border: 1px solid rgba(17, 24, 39, 0.125);
    background-color: white;
  }
`;

export const SearchButton = styled(Button)`
  margin-left: 0.5rem;
`;

export const InputtedWordWrapper = styled.div`
  border: #f26f21 solid 2px;
  border-radius: 500px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0px 8px;
  margin-top: 5px;
  width: fit-content;
`;

export const IconWrapper = styled.div`
  margin-left: 0.5rem;
  cursor: pointer;
`;